import { combineReducers } from "redux";
import { codeEditorSlice } from "./codeEditor";
import { editorSlice } from "./editorSlice";
import { toolbarSlice } from "./toolbar";
import { visualEditorSlice } from "./visualEditor";
import { expressionEditorSlice } from "./expressionEditorSlice";

export const developerEditReducer = combineReducers({
  codeEditor: codeEditorSlice.reducer,
  toolbar: toolbarSlice.reducer,
  editor: editorSlice.reducer,
  visualEditor: visualEditorSlice.reducer,
  expressionEditor: expressionEditorSlice.reducer,
});
